<template>
  <QuillEditor ref="quillIn" :modules="modules" toolbar="full" />
</template>

<script>
import { ref, defineComponent } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import ImageUploader from 'quill-image-uploader'

export default defineComponent({
  components: {
    QuillEditor,
  },
  setup: () => {
    const modules = {
      name: 'imageUploader',
      module: ImageUploader,
      options: {
        upload: (file) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData()
            formData.append('image', file)
            formData.append('type', 'news')
            axios
              .post('/admin/photoUpload', formData)
              .then((res) => {
                console.log(res.data.data.PathUrl)
                resolve(res.data.data.PathUrl)
              })
              .catch((err) => {
                reject('Upload failed')
                console.error('Error:', err)
              })
          })
        },
      },
    }
    return { modules }
  },
})
</script>
